const Initials = (firstName: string, lastName: string, chat?: boolean) => {
  const ret = firstName[0] + lastName[0];

  if (chat) return ret.split('');
  else return ret;
};

export default Initials;
